import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GoToTopComponent } from '@shared/components/go-to-top/go-to-top.component';
import { AuthGuard } from '@shared/guards/auth-guard.service';
import { NotFoundComponent } from '@shared/components/notfound/notfound.component';
import { ErrorPageComponent } from '@shared/components/error-page/error-page.component';
import { SysIdResolver } from '@shared/resolvers/sys-id.resolver';
import { FeatureGuard } from '@shared/guards/feature-guard.service';
import { WebChatComponent } from '@shared/components/web-chat/web-chat.component';
import { FaqComponent } from '@shared/components/faq/faq.component';
import { SettingsResolver } from '@shared/resolvers/settings.resolver';
import { TicketingStatusResolver } from '@shared/resolvers/ticketing-status.resolver';
import { TranslateResolver } from '@shared/resolvers/translation.resolver';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboards/dashboards.module').then(m => m.DashboardsModule),
    canActivate: [AuthGuard, FeatureGuard],
    resolve: {
      userSysId: SysIdResolver,
      ticketingSettings: SettingsResolver,
      statusConstants: TicketingStatusResolver,
      translations: TranslateResolver
    },
    data: {
      accessingFrom: 'login-ad',
      translationsPath: ['assets/i18n/apps/automation']
    }
  },
  {
    path: 'apps',
    loadChildren: () => import('./modules/apps/apps.module').then(m => m.AppsModule),
    canActivate: [AuthGuard, FeatureGuard],
    resolve: {
      userSysId: SysIdResolver
    }
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: { noWrapperClass: true, title: 'CIAP' }
  },
  {
    path: 'faq',
    component: FaqComponent,
    data: { title: 'FAQ' }
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: { title: 'CIAP', noWrapperClass: true }
  },
  { path: 'web-chat', component: WebChatComponent, data: { title: 'CIAP', skipAuthCheck: true } },
  { path: '', redirectTo: 'auth/login-ad', pathMatch: 'full' },
  { path: '**', redirectTo: '404', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [GoToTopComponent]
})
export class RootRoutingModule {}
